import { createContext, useContext } from 'react';
import { DataProps } from '../types/uiTypes';

/**
 * uiText has type any because we could get either or of 4 different versions. It makes it diffuicult to typecheck it here,
 * but we do specify it inside the different components.
 */
export interface ContextProps {
    uiText: any;
    finnkode: string;
    isOwnAd: boolean;
    apiEndpoint: string;
    isPreviewMode: boolean;
    urls: DataProps['urls'];
    brand: string | undefined;
    device: string;
}

const SidebarContext = createContext({} as ContextProps);

export default SidebarContext;

export const useSidebarContext = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('Must be a child of the SidebarContext Provider to use this hook.');
    }
    return context;
};
